// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class ChatInteractionRequest {
    chatId: string;
    conversationId?: string;
}